import { singleSeatGapFromUnavailableSeatRuleOptionsValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const seatPickerSingleSeatGapFromUnavailableSeatRuleConfigValidator = Validator.object({
    enabled: Validator.boolean(),
    options: singleSeatGapFromUnavailableSeatRuleOptionsValidator
});
